import React, { FormEvent, useMemo } from 'react';
import { AccordionIndicator, AccordionOpenCloseIcon } from '../../custom/AccordionIndicators';
import SarInfoRow from './SarInfoRow';
import SarValidationCategoryMapper from '../../../util/SarValidationCategoryMapper';
import { MonacoEditorInstance, MonacoNamespace, SarValidationResult } from '../SarInterfaces';

const YukumluSection = ({ xmlContent, fallbackValue, onChangeYukumlu, validate }: Props) => {
  const errorsArray = validate?.errors ?? [];
  const errorsKey = errorsArray.map((e) => `${e.lineStart}-${e.lineEnd}-${e.message}`).join('|');
  const hasYukumluError = useMemo<boolean>(() => {
    if (!validate || !validate.errors || validate.errors.length === 0) {
      return false;
    }
    const invalidFieldIds = SarValidationCategoryMapper.getInvalidFieldIds(validate.errors);
    return invalidFieldIds.has('yukumlu');
  }, [validate?.errors?.length, errorsKey]);
  const yukumluValue = useMemo(() => {
    if (!xmlContent || xmlContent.trim().length === 0) {
      return fallbackValue;
    }
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlContent, 'text/xml');
    const yukumluElement = xmlDoc.getElementsByTagName('yukumlu')[0];
    return yukumluElement && yukumluElement.textContent ? yukumluElement.textContent : fallbackValue;
  }, [xmlContent, fallbackValue]);

  const handleChange = (event: FormEvent<HTMLInputElement>) => {
    onChangeYukumlu(event.currentTarget.value);
  };
  return (
    <div className={'h-full w-full pr-6  pt-3 2xl:pt-4 flex flex-col gap-y-3'}>
      <div className={'text-[#1D2939] text-base font-semibold'}>XML Document</div>
      <div className={'flex flex-col border rounded-[10px] h-full overflow-y-auto overflow-hidden'}>
        <div className={'flex w-full items-center justify-between px-5 2xl:px-6  text-left bg-white border-b border-[#F2F4F7]'}>
          <div className={'flex items-center gap-x-3 h-[56px] 2xl:h-[58px]'}>
            <AccordionOpenCloseIcon hasError={hasYukumluError} expanded={true} />
            <div className={'flex flex-col'}>
              <span className={`text-xs uppercase tracking-wide ${hasYukumluError ? 'text-f-red-1' : 'text-[#667085]'}`}>Information</span>
              <span className={`text-sm font-semibold ${hasYukumluError ? 'text-f-red-1' : 'text-[#1D2939]'}`}>Yükümlü</span>
            </div>
          </div>
          <AccordionIndicator expanded={true} hasError={hasYukumluError} />
        </div>
        <div className={'flex flex-col'}>
          <SarInfoRow hasError={hasYukumluError} label={'Yükümlü'} infoConfig={{ path: 'yukumlu' }}>
            <div className='flex items-center gap-x-2 w-full'>
              <input
                className={`flex-1 text-right focus:outline-none h-[34px] min-h-[34px] 2xl:h-[36px] 2xl:min-h-[36px] text-sm indent-1 text-f-black-2 bg-white pr-2 ${hasYukumluError ? 'border-f-red-1 border rounded-[4px] placeholder:text-f-red-1 text-f-red-1' : ''}`}
                value={yukumluValue}
                onChange={handleChange}
                placeholder={'Yükümlü Giriniz...'}
              />
            </div>
          </SarInfoRow>
        </div>
      </div>
    </div>
  );
};

interface Props {
  xmlContent?: string;
  fallbackValue: string;
  onChangeYukumlu: (value: string) => void;
  onEditorWillMount: (monaco: MonacoNamespace) => void;
  onEditorDidMount: (editor: MonacoEditorInstance) => void;
  onEditorChange: (value: string | undefined) => void;
  validate?: SarValidationResult;
}

export default YukumluSection;
